import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { CART_KEY, cartReducer, loadCart, loadCheckout, saveCheckout } from './cartState';

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
    const [items, dispatch] = useReducer(cartReducer, undefined, loadCart);
    const [attempt, setAttempt] = useState(loadCheckout);
    useEffect(() => { try { localStorage.setItem(CART_KEY, JSON.stringify(items)); } catch {} }, [items]);
    const updateAttempt = value => { saveCheckout(value); setAttempt(value); };
    const settle = (orderId, paid) => {
        const pending = loadCheckout();
        if (!pending || String(pending.order_id) !== String(orderId)) return;
        if (paid) dispatch({ type: 'paid', items: pending.items });
        updateAttempt(null);
    };
    return <CartContext.Provider value={{ items, dispatch, attempt, updateAttempt, settle,
        count: items.reduce((total, item) => total + item.quantity, 0) }}>{children}</CartContext.Provider>;
}
